module.exports = "/static/assets/29f6558a07459c1787681f11e59eeb6c.png";